import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Constants } from "../../../utils/constants";
import { AuthService } from "../../../services/auth.service";
import { Company } from "../../../model/company";
import { CompaniesService } from "../../../services/companies.service";


@Component({
  selector: 'aw-company-card',
  templateUrl: './company-card-dashboard.component.html',
  styleUrls: ['./company-card-dashboard.component.scss']
})
export class CompanyCardDashboardComponent implements OnInit {

  company?: Company;
  roles = Constants.roles;
  loading = false;
  loggedUser: any;


  constructor(
    public dialog: MatDialog,
    public companyService: CompaniesService,
    public authService: AuthService,
  ) {
  }

  @Input() set element(company: Company) {
    this.company = company;
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

}
